<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!User.isForm" flat class="pa-2 text-no-wrap">
        <h2 class="pa-2">
          {{ $t(`table.filter`) }}
        </h2>
        <v-layout wrap align-center>
          <v-col cols :sm="2" class="pa-2">
            <v-text-field
              :label="$t(`table.search`) + ' NetAloId'"
              dense
              hide-details
              v-model="filter.netAloId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="2" class="pa-2">
            <v-text-field
              :label="$t(`table.search`) + ' UserId'"
              dense
              hide-details
              v-model="filter.userId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="2" class="pa-2">
            <v-text-field
              :label="$t(`table.search`) + ' LomoId'"
              dense
              hide-details
              v-model="filter.lomoId"
              @keydown.enter="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="2" class="pa-2">
            <v-statusDating
              v-model="filter.datingStatus"
              @change="_fnSearch()"
            />
          </v-col>
          <v-col cols :sm="2" class="pa-2">
            <v-statusUser v-model="filter.status" @change="_fnSearch()" />
          </v-col>
        </v-layout>
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="User.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="User.total"
          :items-per-page="User.filter.limit"
          :footer-props="{ itemsPerPageOptions: User.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.user") }}</h2>
              </v-layout>
              <v-spacer />
              <div class="mb-3" :style="{ width: '250px' }">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  v-model="User.search"
                  @keydown.enter="_fnSearch()"
                  :placeholder="$t(`table.search`)"
                />
              </div>
            </v-layout>
          </template>
          <template #[`item.action`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: USER, p: APPROVE }])"
            />
          </template>
          <template #[`item._id`]="{ item }">
            {{ "LomoId: " + (item.lomoId || "") }}<br />
            {{ "NetAloId: " + item.netAloId }}<br />
            {{ "UserId: " + item.id }}<br />
          </template>
          <template #[`item.avatar`]="{ item }">
            <v-upload class="my-1" :size="30" v-model="item.avatar" readonly />
          </template>
          <template #[`item.backgroundImage`]="{ item }">
            <v-upload
              :size="30"
              class="my-1"
              v-model="item.backgroundImage"
              readonly
            />
          </template>
          <template #[`item.datingImages`]="{ item }">
            <v-upload
              :size="30"
              class="my-1"
              :images="item.datingImages.map((e) => e.link)"
              readonly
            />
          </template>
          <template #[`item.numberOfCandy`]="{ item }">
            {{ item.numberOfCandy }}
          </template>
          <template #[`item.datingStatus`]="{ item }">
            <span
              v-if="item.datingStatus"
              :class="
                item.datingStatus.id == '60a37f80fb2da21e0584e90f'
                  ? 'success--text'
                  : item.datingStatus.id == '60a37f80fb2da21e0584e90e'
                  ? 'error--text'
                  : item.datingStatus.id == '60a37f80fb2da21e0584e90d'
                  ? 'warning--text'
                  : 'info--text'
              "
            >
              {{ item.datingStatus.name }}
            </span>
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '5ed349d2e6278057e83adf0e'
                  ? 'success--text'
                  : item.status.id == '5ed349d2e6278057e83adf18' ||
                    item.status.id == '629044d9863d51337441f425'
                  ? 'error--text'
                  : item.status.id == '5ed349d2e6278057e83adf00'
                  ? 'warning--text'
                  : 'info--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "User",
      pagings: {},
      filter: {
        netAloId: "",
        userId: "",
        lomoId: "",
        datingStatus: "",
        status: "",
      },
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "action",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "_id",
          width: "10px",
        },
        {
          text: this.$t(`table.avatar`),
          value: "avatar",
          width: "10px",
        },
        {
          text: this.$t(`table.cover`),
          value: "backgroundImage",
          width: "10px",
        },
        {
          text: this.$t(`table.datingImages`),
          value: "datingImages",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "name",
        },
        {
          text: this.$t(`table.post`),
          value: "numberOfPost",
          width: "10px",
        },
        {
          text: this.$t(`table.bear`),
          value: "numberOfBear",
          width: "10px",
        },
        {
          text: this.$t(`table.candy`),
          value: "numberOfCandy",
          width: "10px",
        },
        {
          text: this.$t(`table.statusDating`),
          value: "datingStatus",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.createdAt`),
          value: "createdAt",
          width: "10px",
        },
      ];
      return table;
    },
  },
  watch: {
    "User.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = {};
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          gender: this[this.model].obj.gender
            ? this[this.model].obj.gender.id
            : "",
          province: this[this.model].obj.province
            ? this[this.model].obj.province.id
            : "",
          status: this[this.model].obj.status.id,
          datingStatus: this[this.model].obj.datingStatus
            ? this[this.model].obj.datingStatus.id
            : "",
        };
      }
    },
    _fnCallListView() {
      delete this[this.model].filter.netAloId;
      if (this.filter.netAloId) {
        this[this.model].filter.netAloId = this.filter.netAloId;
      }
      delete this[this.model].filter._id;
      if (this.filter.userId) {
        this[this.model].filter._id = this.filter.userId;
      }
      delete this[this.model].filter.lomoId;
      if (this.filter.lomoId) {
        this[this.model].filter.lomoId = this.filter.lomoId;
      }
      delete this[this.model].filter.datingStatus;
      if (this.filter.datingStatus) {
        this[this.model].filter.datingStatus = this.filter.datingStatus;
      }
      delete this[this.model].filter.status;
      if (this.filter.status) {
        this[this.model].filter.status = this.filter.status;
      }
      delete this[this.model].filter.$text;
      if (this[this.model].search) {
        this[this.model].filter.$text = this[this.model].search;
      }
      this.fnCallListView({
        url: "/v1/admin/user",
        model: this.model,
      });
    },
    _fnSearch() {
      this._fnCallListView();
    },
  },
};
</script>
